// Deduplicates concurrent /cart.js fetches when multiple controls initialise at once
let sharedCartFetch = null;
function fetchCart() {
  if (!sharedCartFetch) {
    sharedCartFetch = fetch('/cart.js')
      .then((r) => r.json())
      .finally(() => {
        sharedCartFetch = null;
      });
  }
  return sharedCartFetch;
}

class QuickAddControl extends HTMLElement {
  #productId = 0;
  #variantId = 0;
  #hasVariants = false;
  #productUrl = '';
  #unsubscribe = null;
  #cardInner = null;

  connectedCallback() {
    this.#productId = parseInt(this.dataset.productId, 10);
    this.#variantId = parseInt(this.dataset.variantId, 10);
    this.#hasVariants = this.dataset.hasVariants === 'true';
    this.#productUrl = this.dataset.productUrl || '';

    fetchCart().then((cart) => this.#update(cart));

    this.#unsubscribe = subscribe('cart-update', () => {
      fetchCart().then((cart) => this.#update(cart));
    });

    // Make the card image/media area navigate to the product page.
    // CSS z-index stacking contexts prevent the Dawn ::after overlay from
    // working here, so we delegate via JS instead.
    if (this.#productUrl) {
      this.#cardInner = this.closest('.card__inner');
      this.#cardInner?.addEventListener('click', this.#handleCardClick);
    }
  }

  disconnectedCallback() {
    this.#unsubscribe?.();
    this.#cardInner?.removeEventListener('click', this.#handleCardClick);
    this.#cardInner = null;
  }

  // Navigate to the product page when the click lands outside any interactive
  // element belonging to the quick-add control (button, link, modal, form…).
  #handleCardClick = (e) => {
    if (!e.target.closest('a, button, [role="button"], quick-add-control')) {
      window.location.href = this.#productUrl;
    }
  };

  #update(cart) {
    const qty = this.#hasVariants
      ? cart.items
          .filter((i) => i.product_id === this.#productId)
          .reduce((sum, i) => sum + i.quantity, 0)
      : (cart.items.find((i) => i.variant_id === this.#variantId)?.quantity ?? 0);

    this.classList.toggle('is-active', qty > 0);

    const btn = this.querySelector('.card-quick-add-btn');
    if (!btn) return;

    if (qty > 0) {
      btn.dataset.cartCount = qty;
    } else {
      delete btn.dataset.cartCount;
    }
  }
}

customElements.define('quick-add-control', QuickAddControl);
